import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {LogisticRoutesService} from '../../data/logistic-routes.service';
import {RouteVehicle} from '../../data/route-vehicle';
import {MatDialog} from '@angular/material/dialog';

import {
  LogisticVehicleEditDialogComponent
} from './logistic-vehicle-edit-dialog/logistic-vehicle-edit-dialog.component';
import {ProjectActivity} from '../../../project-misc/data/project/activity/project-activity';
import {
  ProjectWindowComponent
} from '../../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {MiscSnackBarService} from '../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import moment from 'moment';
import {Subscription} from 'rxjs';
import {WsUpdateResponce} from '../../../data/ws-update-responce';
import {WsService} from '../../../data/ws.service';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-logistic-route-page',
  templateUrl: './logistic-route-page.component.html',
  styleUrls: ['./logistic-route-page.component.scss']
})
export class LogisticRoutePageComponent implements OnInit, OnDestroy {
  routeVehicles: RouteVehicle[];
  vehiclesLoading = true;

  moveVehicleId = -1;
  smsId = -1;

  linkId = -1;
  optimizeId = -1;

  todayActivities: ProjectActivity[];

  chosenVehicleCounter = 0;

  wsSub: Subscription;

  currentDate = moment().format('MMMM D')

  nextWeekStart = moment().add(1, 'weeks').startOf('isoWeek').format('MMMM D');
  nextWeekEnd = moment().add(1, 'weeks').endOf('isoWeek').format('MMMM D');

  updateQueue: RouteVehicle[] = [];

  dndActive = false;

  constructor(
    protected wsService: WsService,
    protected logisticRoutesService: LogisticRoutesService,
    protected miscSnackBarService: MiscSnackBarService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected matDialog: MatDialog
  ) {
    // this.changeDetectorRef.detach()
  }

  ngOnInit(): void {
    this.getVehicles();
    this.getActivityForToday();

    this.subToSocket()
  }

  subToSocket() {

    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<RouteVehicle>>('/topic/update/model.pricing.routing.acvehicle', this)
      .subscribe(res => {

        const veh = res.entity;

        const fVeh = this.routeVehicles.find(routeV => routeV.id === veh.id)

        if (fVeh) {
          this.updateQueue.push(veh)
          this.updateAll();
        }

      })
  }


  getActivityForToday() {
    const today = moment().format('YYYY-MM-DD')

    this.logisticRoutesService.getDeliveryActivities(today, today).subscribe(res => {
      this.todayActivities = res;
    })
  }

  getVehicles() {
    this.logisticRoutesService.getVehicles().subscribe(vehicles => {
      this.routeVehicles = vehicles

      this.vehiclesLoading = false;
    })
  }

  editVehicle(vehicle: RouteVehicle, index: number) {
    const dialogRef = this.matDialog.open(LogisticVehicleEditDialogComponent, {
      data: {
        vehicle
      },
      panelClass: 'vehicle-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.routeVehicles[index] = res
      }
    })
  }

  createVehicle() {
    const dialogRef = this.matDialog.open(LogisticVehicleEditDialogComponent, {
      data: {
        vehicle: null
      },
      panelClass: 'vehicle-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getVehicles()
    })
  }

  openProject(projectId: number) {
    const dialogRef = this.matDialog.open(ProjectWindowComponent, {
      data: {
        projectNumber: projectId,
      },
      panelClass: 'project-window-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getVehicles()
    })
  }

  sendSMS(vehicle: RouteVehicle) {
    this.smsId = vehicle.id

    this.logisticRoutesService.sendSmsToUser(vehicle.id).subscribe(() => {
      this.miscSnackBarService.openSuccessSnackBar('SMS Was Successfully Sent!');
      this.smsId = -1;
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.smsId = -1;
    })
  }

  openLink(vehicle: RouteVehicle) {
    const windowReference = window.open();
    windowReference.location.assign(vehicle.routeUrl);
  }

  approveVehicle(vehicle: RouteVehicle) {
    this.logisticRoutesService.editVehicle({
      id: vehicle.id,
      status: {
        id: 56,
        active: true,
        clazz: 'VEHICLE_STATUS',
        color: `0098b7`,
        name: 'Approved',
        pos: 5,
        shortTitle: 'APPR',
        title: 'Approved'
      }
    }).subscribe(newVeh => {
      vehicle.status = newVeh.status
    })
  }

  driveOut(vehicle: RouteVehicle) {
    this.logisticRoutesService.editVehicle({
      id: vehicle.id,
      status: {
        id: 55,
        active: true,
        clazz: 'VEHICLE_STATUS',
        color: `2E5CC4`,
        name: 'On Route',
        pos: 10,
        shortTitle: 'OR',
        title: 'On Route'
      }
    }).subscribe(newVeh => {
      vehicle.status = newVeh.status
    })
  }


  ngOnDestroy() {
  }


  vehicleRouteDropped(event: CdkDragDrop<any>, vehicle?: RouteVehicle) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }

    const className = event.previousContainer.element.nativeElement.classList[1]
    const timeStamp = moment().format('YYYY-MM-DDTHH:mm:ss')


    if (className.includes('vehicle-index')) {
      const index = className.split('-').pop()
      this.routeVehicles[index].lastInteractionTime = timeStamp
    }


    const routes = event.container.data as ProjectActivity[]
    const routedIds = routes.map(act => act.id)

    if (vehicle) {
      this.moveVehicleId = vehicle.id
      this.linkId = vehicle.id;
      vehicle.lastInteractionTime = timeStamp

      this.updateAll()

      if (event.previousContainer === event.container) {

        this.logisticRoutesService.moveWaypoint(vehicle.id, vehicle.activities[event.currentIndex].id, event.currentIndex).subscribe(newVeh => {
          vehicle.routeUrl = newVeh.routeUrl

          vehicle.routeOptimized = newVeh.routeOptimized;

          this.moveVehicleId = -1;
          this.linkId = -1;
        })
      } else {

        this.logisticRoutesService.updateVehicleRoute(vehicle.id, vehicle.lastInteractionTime, routedIds).subscribe(() => {
          this.moveVehicleId = -1;
          this.linkId = -1;
        })
      }
    } else {
      this.updateAll()

      this.moveVehicleId = 0
      this.logisticRoutesService.unloadRoutes(routedIds).subscribe(() => {
        this.moveVehicleId = -1;
      })
    }
  }

  optimizeRoute(vehicle: RouteVehicle) {
    this.optimizeId = vehicle.id

    this.logisticRoutesService.optimizeVehicle(vehicle.id, vehicle.activities.map(ac => ac.id)).subscribe(newVeh => {
      vehicle.activities = newVeh.activities
      vehicle.routeUrl = newVeh.routeUrl
      vehicle.totalDuration = newVeh.totalDuration

      vehicle.routeOptimized = newVeh.routeOptimized;

      this.optimizeId = -1;
    }, () => {
      this.optimizeId = -1;
    })
  }


  getDuration(duration: number) {
    const totalHours = Math.trunc(duration / 60 / 60)
    const totalMinutes = Math.trunc((duration - totalHours * 60 * 60) / 60)

    return totalHours + 'h:' + totalMinutes + 'm';
  }

  updateAll() {
    while (this.updateQueue.length > 0) {
      if (this.dndActive) {
        break;
      } else {
        const updatedVeh = this.updateQueue.shift()
        const fVeh = this.routeVehicles.find(routeV => routeV.id === updatedVeh.id)

        if (fVeh) {
          const diffSeconds = moment(updatedVeh.lastInteractionTime).diff(fVeh.lastInteractionTime, 'seconds')

          if (diffSeconds >= 0) {
            fVeh.routeUrl = updatedVeh.routeUrl
            fVeh.totalDuration = updatedVeh.totalDuration
            fVeh.activities = updatedVeh.activities
            fVeh.routeOptimized = updatedVeh.routeOptimized
          }
        }
      }
    }
  }

  dndStart() {
    this.dndActive = true;
  }

  dndEnd() {
    this.dndActive = false;
  }
}
